"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Body1Stronger", {
    enumerable: true,
    get: function() {
        return Body1Stronger;
    }
});
const _createPreset = require("../createPreset");
const _useBody1StrongerStylesstyles = require("./useBody1StrongerStyles.styles");
const Body1Stronger = (0, _createPreset.createPreset)({
    useStyles: _useBody1StrongerStylesstyles.useBody1StrongerStyles,
    className: _useBody1StrongerStylesstyles.body1StrongerClassNames.root,
    displayName: 'Body1Stronger'
});
